import { render, staticRenderFns } from "./bulkGene.vue?vue&type=template&id=3a1ddaa0&"
import script from "./bulkGene.vue?vue&type=script&lang=js&"
export * from "./bulkGene.vue?vue&type=script&lang=js&"
import style0 from "./bulkGene.vue?vue&type=style&index=0&id=3a1ddaa0&prod&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports